import { mapActions, mapGetters } from 'vuex';
import { getObjectPropertyValueByPath } from '_/helpers/lodashHelper';

export default {
    /**
     * Set the computed properties
     *
     * @type {object}
     */
    computed: {
        ...mapGetters({
            admin: 'admin/admin',
        }),
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        ...mapActions('admin', ['extensionCall']),

        getObjectPropertyValueByPath,
    },
};
